import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-favoritos-info-modal',
  templateUrl: './favoritos-info-modal.component.html',
  styleUrls: ['./favoritos-info-modal.component.scss'],
})
export class FavoritosInfoModalComponent {

  public texts: {
    subtitle: string;
    howToWinTitle: string;
    howToWinText: string;
    favProductsTitle: string;
    favProductsText: string;
    tagNotCompletedTitle: string;
    tagNotCompletedSubtitle: string;
    tagCompletedTitle: string;
    tagCompletedSubtitle: string;
    importantTitle: string;
    importantText: string;
  };

  constructor(private translateS: TranslateService) {
    this.texts = this.translateS.instant('Modals.portafolio.component-info');
  }
}
